if (!Array.prototype.at)
  Array.prototype.at = function (index) {
    return index < 0
    ? this[this.length + index]
    : this[index]
  }
